import {makeAutoObservable} from 'mobx';
import {RootStore} from './RootStore';
import AdminApiManager from 'services/API/AdminApi/AdminApiManager';
import {
  GroupInfoResponse,
  StudentData,
} from 'services/API/AdminApi/AdminApiModels';
import {PersonalData} from 'models/Admin';
import {AdminGroupsStore} from './AdminGroupsStore';
import { generateTempUid } from 'helpers/generateTempId';
import strings from 'translations/index.web';

export interface IAdminGroupsStudentsStore {
  students: StudentData[];

  mapGroupToRequestFormat: () => StudentData[];

  getStudentsForGroup: (groupId: string) => Promise<GroupInfoResponse>;
}

export class AdminGroupsStudentsStore implements IAdminGroupsStudentsStore {
  private adminApiManager = new AdminApiManager();

  rootStore: RootStore;
  groupsStore: AdminGroupsStore;
  students: StudentData[] = [
    {
      name: '',
      surname: '',
      email: '',
      id: '',
      role: '',
      tenantId: '',
      image: '',
    },
  ];
  groupName: string = '';
  groupId: string = '';

  constructor(rootStore: RootStore, groupsStore: AdminGroupsStore) {
    this.rootStore = rootStore;
    this.groupsStore = groupsStore;

    makeAutoObservable(this);
  }

  setStudents = (data: StudentData[]) => {
    this.students = data;
  };

  setField = (value: string, arrIndex: number, fieldType: string) => {
    let key = fieldType as keyof StudentData;
    this.students[arrIndex][key] = value;
  };

  setGroupName = (value: string) => {
    this.groupName = value;
  };

  setGroupId = (value: string) => {
    this.groupId = value;
  }

  deleteStudent = (deletable: PersonalData) => {
    let filteredData = this.students.filter(item => item !== deletable);
    this.setStudents(filteredData);
  };

  addStudent = (item: StudentData) => {
    let newFlatList = [...this.students, {...item}];
    this.setStudents(newFlatList);
  };

  addEmptyStudent = () => {
    let item: StudentData = {
      name: '',
      surname: '',
      email: '',
      id: '',
      role: '',
      tenantId: '',
      image: '',
    };

    this.addStudent(item);
  };

  setGroup = (id: string, title: string) => {
    const groupId = id ? id : generateTempUid()
    this.setGroupId(groupId);

    if (id === undefined) {
      this.groupsStore.addTemplateGroup(groupId);
    }

    if (title != strings.admin.createGroup) {
      this.setGroupName(this.groupsStore.getGroupById(groupId).name);
      this.getStudentsForGroup(groupId);
    }
  }

  mapGroupToRequestFormat = () => {
    let mappedGroup: StudentData[] = [];
    this.students.forEach(item => {
      let mappedStudent: StudentData = {
        id: '',
        email: item.email,
        name: item.name,
        surname: item.surname,
        role: '',
        tenantId: '',
        image: '',
      };
      mappedGroup.push(mappedStudent);
    });

    return mappedGroup;
  };

  async getStudentsForGroup(groupId: string) {
    this.rootStore.loaderStore.startLoading();

    let result: GroupInfoResponse = {
      id: '',
      name: '',
      students: [],
    };

    try {
      result = await this.adminApiManager.getGroupById(groupId);
      this.setStudents(result.students);
    } catch (error) {
      console.log(error);
    } finally {
      this.rootStore.loaderStore.stopLoading();
    }

    return result;
  }
}
